import i18n from '/common/plugins/vue-i18n.js' 
let lang = window.localStorage.getItem('language');
if(!lang)	
{
    lang = "zh_TW"				
}
i18n.locale = lang


const GPTModelList =  [
    {name:"GPT-5.6 Sol",id:"gpt56-sol"},
    {name:"GPT-5.6 Terra",id:"gpt56-terra"},
    {name:"GPT-5.6 Luna",id:"gpt56-luna"},
    // GPT-5.4 mini / nano 不放這裡：它們比照現行 GPT-5 mini / nano 的做法，
    // 只在原本就看得到新一代模型的管道出現，所以掛在 AiBot.vue / addAiBot.vue
    // 的 gpt5_series（受 gpt5_channel 閘門限制）。GPT-5.6 三變體才是全管道可選。
    {name:"GPT 4o",id:"gpt4o"},
    {name:"GPT 4o mini",id:"gpt4o-mini"},
    {name:"GPT 4.1",id:"gpt41"},
    {name:"GPT 4.1 mini",id:"gpt41-mini"},
    {name:"GPT 4.1 nano",id:"gpt41-nano"},
    // {name:"GPT 5",id:"gpt5"},
    // {name:"GPT-5 mini",id:"gpt5-mini"},
    // {name:"GPT-5 nano",id:"gpt5-nano"},
];

export default GPTModelList;